import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import './pending-attendance.scss';
import Icon from '../icon/icon';
import TakeAttendanceByOne from '../take-attendance-by-one/take-attendance-by-one';

import format from 'date-fns/format';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { RESERVES_BRANCH } from '../../graphql/branch';
import IFilterAttedance from '../../interfaces/filters-attendace.interface';

let filters: IFilterAttedance;

export const PendingAttendance = () => {

    const { id }: any = useParams();
    const [dates, setDates] = useState({ current: new Date(), threeDaysAgo: new Date() });
    const [pendingAttendance, setPendingAttendance] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedCalendarId, setSelectedCalendarId] = useState(null);

    useEffect(() => {
        const getCurrentAndThreeDaysAgoDates = () => {
          const now = new Date();
          const formattedCurrentDate = new Date(now);
          now.setDate(now.getDate() - 8);
          const formattedThreeDaysAgoDate = new Date(now);
          setDates({ current: formattedCurrentDate, threeDaysAgo: formattedThreeDaysAgoDate });
        };
    
        getCurrentAndThreeDaysAgoDates();
      }, []);

    filters = {
        idBranch: parseInt(id),
        start: dates.threeDaysAgo,
        end: dates.current,
        status: [1,13],
        page: 1
    };

    const { data } = useQuery(RESERVES_BRANCH, {
        variables: filters,
    });

    const callToggleDrawer = (id: any) => {
        setSelectedCalendarId(id);
        setIsOpen(prevIsOpen => !prevIsOpen);
    };

    useEffect(() => {
        if (data?.reservesBranch?.data.length > 0) {
            const updatePendingAttendance = () => {
                const now = new Date();
                const updatedData = data.reservesBranch.data.map((el: any) => {
                    const endTime = new Date(el.end);
                    const timeDiff = endTime.getTime() - now.getTime();
                    const hoursLeft = Math.floor(timeDiff / (1000 * 60 * 60));
                    const minutesLeft = Math.floor((timeDiff / (1000 * 60)) % 60);
                    const secondsLeft = Math.floor((timeDiff / 1000) % 60);

                    let color = '#02BAA5';
                    if (hoursLeft <= -24) {
                        color = '#F82E4B';
                    } else if (hoursLeft <= -1) {
                        color = '#F79C2F';
                    }

                    return {
                        ...el,
                        hour: format(new Date(el.start), 'HH:mm'),
                        name: el.classFit.name,
                        timeLeft: timeDiff,
                        color: color,
                        hoursLeft: (hoursLeft < 0 || minutesLeft < 0 || secondsLeft < 0) ? `Hace ${Math.abs(hoursLeft)}` : hoursLeft,
                        minutesLeft: (minutesLeft < 0) ?  Math.abs(minutesLeft) : minutesLeft,
                        secondsLeft: (secondsLeft < 0) ?  Math.abs(secondsLeft) : secondsLeft
                    };
                });
                
                setPendingAttendance(updatedData);
            };

            updatePendingAttendance();
            const interval = setInterval(updatePendingAttendance, 1000); // Actualizar cada segundo

            return () => clearInterval(interval);
        }
    }, [data?.reservesBranch?.data]);

    return (
        <>
            {
                pendingAttendance.length > 0 && (
                    <Card id="pending-attendance" className="mb-2">
                        <CardContent>
                            <h2>Asistencias pendientes</h2>
                            <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                Gestiona rápidamente tus asistencias pendientes
                            </Typography>
                            <div className="mt-1 mb-1">
                                {pendingAttendance.map((el: any, index: number) => (
                                    <span key={index} className={`mr-1 badge-attendance badge-${el.color}`}
                                        onClick={() => callToggleDrawer(el.id)}>
                                        {el.name} {el.hour}
                                        <span className="ml-05 mr-05">|</span>
                                        <Box sx={{ display: 'inline-flex', verticalAlign: 'sub', lineHeight: '15px' }} style={{ color: el.color }}>
                                            <Icon name='clock' color={el.color} width='15' height='15'></Icon>
                                            &nbsp;{el.hoursLeft}h {el.minutesLeft}m {el.secondsLeft}s
                                        </Box>
                                    </span>
                                ))}
                                {selectedCalendarId && isOpen && (
                                    <TakeAttendanceByOne calendarId={selectedCalendarId} isOpenModal={isOpen} setIsOpen={setIsOpen} />
                                )}

                            </div>
                            <div className="alert-attendance mt-2">
                                <Box sx={{ display: 'inline-flex', verticalAlign: 'sub', lineHeight: '20px', alignItems: 'center' }} className='ml-05'>
                                    <Icon name='clock' width='20' height='20'></Icon>
                                    <span className='ml-05'>
                                        Toma tu asistencia antes de que se acabe el tiempo para evitar reprocesos.
                                    </span>
                                </Box>
                            </div>
                        </CardContent>
                    </Card>
                )
            }
        </>
    );
};